import React, { useCallback, useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";

import "./AlbumsPage.css";

// Jds
import {
  ActionButton,
  Button,
  Container,
  Icon,
  Notifications,
  Selectors,
  Skeleton,
  Spinner,
  Text,
} from "@jds/core";

// Mui

// Local
import AddButton from "../components/UI/Buttons/AddButton";
import JdsModal from "../components/UI/JdsModal";
import FolderForm from "../components/UI/Form/FolderForm";
import EmptyState from "../components/NoData/EmptyState";
import AlbumCard from "../components/UI/Cards/AlbumCard";
import useApiHttp from "../hooks/use-http";
import SuccessModal from "../components/UI/SuccessModal/SuccessModal";
import PageLoader from "../components/UI/Loader/PageLoader";
import { baseToImg } from "../util/helper";
import Loader from "../components/UI/Loader/Loader";
import {
  setActiveModalClose,
  setPlanModalClose,
  setPremiumPlanId,
} from "../store/state-slices/plans";
import IconRocket from "../assets/svg/ic_enterpreneurial.svg";
import { useDispatch, useSelector } from "react-redux";
import ActiveAlertContainer from "../components/UI/ActiveAlertContainer/ActiveAlertContainer";
import { Box, FormControlLabel, Switch } from "@mui/material";
import PhotographerAccess from "../components/UI/Views/permission/PhotographerAccess";

export default function Albums() {
  const { id: eventId } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const { eventDetails } = useSelector((state) => state.eventDetails);
  const isPhotographer = eventDetails?.userRole == "PHOTOGRAPHER";
  const [planActive, setPlanActive] = useState(true);
  const [planActiveMsg, setPlanActiveMsg] = useState("");
  const [folderList, setFolderList] = useState([]);
  const [apiSuccess, setApiSuccess] = useState(true);
  const [isSuccessModalClosed, setSuccessModalClose] = useState(true);
  const [lastPage, setLastPage] = useState(0);
  const [editData, setEditData] = useState({});
  const [isEditModalClose, setEditModalClose] = useState(true);
  const [isDeleteModalClose, setDeleteModalClose] = useState(true);
  const [isApproveModalClose, setApproveModalClose] = useState(true);
  const [isDeleteThumbnailModalClose, setDeleteThumbnailModalClose] =
    useState(true);
  const [isPhotographerAccessModalClose, setPhotographerAccessModalClose] =
    useState(true);
  const [isCreateModalClose, setCreateModalClose] = useState(true);
  const [
    switchFolderPublicConfirmationModalClose,
    setSwitchFolderPublicConfirmationModalClose,
  ] = useState(true);
  const [isWatermarkAvailable, setIsWatermarkAvailable] = useState(false);
  const [isPublic, setIsPublic] = useState(false);
  const [tabIndex, setTabIndex] = useState(() => {
    if (location?.state?.photographerTab) {
      return 1;
    } else {
      return 0;
    }
  });

  const [page, setPage] = useState(0);
  const { isAdmin } = useSelector((state) => state.role);

  const loginDetails = useSelector((state) => state.auth.loginDetails);
  const isJitoUser = loginDetails?.userType === "JITO";

  // API calls
  const { sendRequest: getFoldersReq, isLoading: isFolGeting } = useApiHttp();
  const {
    sendRequest: addFolderRequest,
    success: folderSubmitSuccess,
    isLoading: isFolActionLoading,
  } = useApiHttp();
  const { sendRequest: deleteFolderRequest, isLoading: isDeleting } =
    useApiHttp();
  const { sendRequest: approveFolderRequest, isLoading: isApprove } =
    useApiHttp();
  const {
    sendRequest: deleteThumbnailRequest,
    isLoading: isDeletingThumbNail,
  } = useApiHttp();
  const { sendRequest: getWatermarkReq, isLoading: waterReqGeting } =
    useApiHttp();

  const { sendRequest: getEventDetReq, isLoading: eventDetReqGeting } =
    useApiHttp();

  const { sendRequest: makeFolderPublicReq, isLoading: isPublicLoading } =
    useApiHttp();

  //Get Folder
  const getFoldersHandler = () => {
    getFoldersReq(
      {
        url: isPhotographer
          ? `event-folders/photographer/get-event-folder/${eventId}?page=${page}&size=25`
          : `event-folders/get-event-folder/${eventId}?page=${page}&size=25&tab=${tabIndex === 0 ? "EVENT" : "PHOTOGRAPHER"
          }`,
      },
      null,
      (data) => {
        if (page == 0) {
          setFolderList(data.data.results);
          setLastPage(data?.data.lastPage);
        } else {
          setFolderList((pre) => [...pre, ...data.data.results]);
          setLastPage(data?.data.lastPage);
        }
      },
      (err, data) => {
        if (data?.statusCode == 402 || data?.statusCode == 403) {
          setPlanActive(false);
          if (eventDetails?.userRole == "ADMIN") {
            setPlanActiveMsg(data?.message);
          } else {
            setPlanActiveMsg(data?.message);
          }
        } else {
          Notifications.toast.error({
            id: "get-folder",
            title: data?.message,
          });
        }
      },
    );
  };

  // Add Folder
  const formAddHandler = (data) => {
    addFolderRequest(
      {
        url: `event-folders/create-folder`,
        method: "POST",
        body: data,
      },
      null,
      (data) => {
        Notifications.toast.success({
          title: data?.message || "Folder created successfully",
          id: "create-folder",
        });
        setFolderList([]);
        if (page !== 0) {
          setPage(0);
        } else {
          getFoldersHandler();
        }
        setCreateModalClose(true);
      },
      (err, res) => {
        Notifications.toast.error({ id: "create-folder", title: res?.message });
        setCreateModalClose(true);
      },
    );
  };

  // Edit Folder
  const folderUpdateHandler = (data, folderId) => {
    addFolderRequest(
      {
        url: `event-folders/update-folder/${folderId}`,
        method: "PUT",
        body: data,
      },
      null,
      (data) => {
        console.log("is1234", data);
        setEditModalClose(true);
        Notifications.toast.success({
          id: "update-folder",
          title: data?.message,
        });
        setFolderList((pre) =>
          pre.map((item) =>
            editData.id == item.id
              ? {
                ...item,
                name: data?.data?.name,
                date: data?.data?.date,
                isPremium: data?.data?.isPremium,
              }
              : item,
          ),
        );
      },
      (err, data) => {
        setEditModalClose(true);
        Notifications.toast.error({
          id: "update-folder",
          title: data?.message,
        });
      },
    );
  };

  // Delete Folder
  const deleteFolderHandler = (id) => {
    deleteFolderRequest(
      {
        url: `event-folders/delete-folder`,
        method: "DELETE",
        body: {
          id,
          eventId,
        },
      },
      null,
      (data) => {
        // setDeleteModalClose(true);
        Notifications.toast.success({
          title: data.message,
          id: "delete-folder",
        });
        setFolderList((pre) => pre.filter((item) => item.id !== editData.id));
      },
      (err, data) => {
        setDeleteModalClose(true);
        Notifications.toast.error({
          title: data.message,
          id: "delete-folder",
        });
      },
    );
  };

  // Approve Folder
  const approveFolderHandler = (id) => {
    approveFolderRequest(
      {
        url: `event-folders/${id}/set-folder-privacy?eventId=${eventId}&status=true`,
        method: "PATCH",
        body: {
          id,
          eventId,
        },
      },
      null,
      (data) => {
        setApproveModalClose(true);
        Notifications.toast.success({
          title: data.message,
          id: "approve-folder",
        });
        setFolderList((pre) =>
          pre.map((item) =>
            id == item.id
              ? {
                ...item,
                photographerFolderImagesCounts: {
                  disapproveCount: 0,
                },
              }
              : item,
          ),
        );
      },
      (err, data) => {
        setApproveModalClose(true);
        Notifications.toast.error({
          title: data.message,
          id: "approve-folder",
        });
      },
    );
  };

  // Delete Thumbnail
  const deleteThumbnailHandler = (editData) => {
    console.log(editData);
    deleteThumbnailRequest(
      {
        url: `event/delete-thumbnail?folderId=${editData.id}`,
        method: "DELETE",
      },
      null,
      (data) => {
        setFolderList((pre) =>
          pre.map((item) =>
            editData.id == item.id
              ? {
                ...item,
                thumbnailImage: null,
              }
              : item,
          ),
        );
        setDeleteThumbnailModalClose(true);
        Notifications.toast.success({
          title: data.message,
          id: "delete-folder-thumbnail",
        });
      },
      (err, data) => {
        setDeleteThumbnailModalClose(true);
        Notifications.toast.error({
          title: data.message,
          id: "delete-folder-thumbnail",
        });
      },
    );
  };

  // Watermark details
  const getWatermarkDetails = () => {
    getWatermarkReq(
      {
        url: `watermark/event/${eventId}`,
        base: "MEDIA",
      },
      null,
      (data) => {
        data.statusCode == 200
          ? setIsWatermarkAvailable(true)
          : setIsWatermarkAvailable(false);
      },
      (err, data) => {
        Notifications.toast.error();
      },
    );
  };
  // Watermark details
  const getEventDetails = () => {
    getEventDetReq(
      {
        url: `event/get-event/${eventId}`,
      },
      null,
      (data) => {
        dispatch(setPremiumPlanId(data?.data?.planId));
      },
      (err, data) => {
        Notifications.toast.error();
      },
    );
  };

  // Make Folder Public
  const makeFolderPublicApiHandler = (editData) => {
    console.log(editData);
    makeFolderPublicReq(
      {
        url: `event-folders/switch-public-access/${editData.id}`,
        method: "PATCH",
      },
      null,
      (data) => {
        setFolderList((pre) =>
          pre.map((item) =>
            editData.id == item.id
              ? {
                ...item,
                isPublic: !editData?.isPublic,
              }
              : item,
          ),
        );
        setSwitchFolderPublicConfirmationModalClose(true);
        Notifications.toast.success({
          title: data.message,
          id: "switch-folder-public",
        });
      },
      (err, data) => {
        setSwitchFolderPublicConfirmationModalClose(true);
        Notifications.toast.error({
          title: data.message,
          id: "switch-folder-public",
        });
      },
    );
  };

  // handle tab change
  const handleTabChange = (value, i) => {
    if (i !== tabIndex) {
      setTabIndex(i);
      setFolderList([]);
      setPage(0);
    }
  };
  // useEffect(() => {
  //   const handleScroll = (e) => {
  //     const scrollHeight = document?.querySelector("#root-layout").scrollHeight;
  //     const currentHeight =
  //       document?.querySelector("#root-layout").scrollTop + window.innerHeight;

  //     if (
  //       currentHeight + 300 >= scrollHeight &&
  //       page < lastPage &&
  //       !isFolGeting
  //     ) {
  //       setPage(page + 1);
  //     }
  //   };
  //   document
  //     ?.querySelector("#root-layout")
  //     ?.addEventListener("scroll", handleScroll);
  //   return () => {
  //     document
  //       ?.querySelector("#root-layout")
  //       ?.removeEventListener("scroll", handleScroll);
  //   };
  // }, [page, lastPage, isFolGeting]);

  useEffect(() => {
    getFoldersHandler();
  }, [page, tabIndex]);

  useEffect(() => {
    // getWatermarkDetails();
    getEventDetails();
  }, []);

  const observerRef = useRef(null);
  const lastElementRef = useCallback(
    (node) => {
      if (isFolGeting) return;
      if (observerRef.current) observerRef.current.disconnect();
      observerRef.current = new IntersectionObserver((element) => {
        if (element[0].isIntersecting && lastPage > page) {
          setPage((pre) => pre + 1);
        }
      });
      if (node) observerRef.current.observe(node);
    },
    [isFolGeting, lastPage],
  );

  if (!planActive) {
    return (
      <div
        style={{
          height: "calc(100vh - 120px)",
          display: "flex",
          alignItems: "center",
        }}>
        <ActiveAlertContainer message={planActiveMsg} />
      </div>
    );
  }
  return (
    <>
      <Container
        className="wrapped"
        horizontalAlign="space-between"
        fullWidth
        style={{
          paddingTop: "32px",
          marginTop: "-32px",
          position: "sticky",
          top: "72px",
          backgroundColor: "white",
          paddingBottom: "16px",
          zIndex: 30,
        }}>
        <Container direction="column" gap={14}>
          <Text
            text="Albums"
            appearance="heading-xs"
            className="albumpage-heading"
          />
        </Container>

        <Container gap={"16px"} className="wrapped">
          {isAdmin && !isJitoUser && (
            <ActionButton
              className="albumpage-button"
              kind="secondary"
              label="Share Photos"
              icon="IcShare"
              size="medium"
              onClick={() => {
                navigate(`/home/events/share/${eventId}`);
                // navigate(`/home/events/guests/${eventId}`, {
                //   state: { requestAccess: true },
                // });
              }}
            />
          )}
          {isAdmin && (
            <ActionButton
              kind="primary"
              className="albumpage-button"
              appearance="normal"
              label="New Folder"
              icon="IcAdd"
              onClick={() => {
                setCreateModalClose(false);
                setApiSuccess(false);
              }}
            />
          )}
        </Container>

        <JdsModal
          header="Add Folder"
          size="m"
          close={isCreateModalClose}
          onClose={() => {
            setCreateModalClose(true);
          }}>
          {!isCreateModalClose && (
            <FolderForm
              isWatermarkAvailable={isWatermarkAvailable}
              onSubmit={(data) => {
                setApiSuccess(false);
                setPage(0);
                formAddHandler({
                  ...data,
                  folderType: tabIndex === 0 ? "EVENT" : "PHOTOGRAPHER",
                });
              }}
              apiSuccess={apiSuccess}
              actionLoading={isFolActionLoading}
              photograherTab={tabIndex == 1}
            />
          )}
        </JdsModal>
      </Container>
      {isAdmin && (
        <Container style={{ maxWidth: "720px" }} fullWidth>
          <Selectors
            stretch
            selectedIndex={tabIndex}
            onChange={handleTabChange}
            items={[
              {
                label: "Event Albums",
                value: "EVENT",
              },
              {
                label: "Photographer Albums",
                value: "PHOTOGRAPHER",
              },
            ]}
          />
        </Container>
      )}

      <div>
        <Container
          fullWidth
          horizontalAlign="start"
          gap={16}
          style={{ marginTop: "32px", flexWrap: "wrap" }}>
          {/* {isLoading ? (
          <Skeleton shape="square" width="184" animated />
        ) :  */}
          {isFolGeting && page === 0 && (
            <Container
              fullWidth
              horizontalAlign="center"
              verticalAlign="center"
              style={{ minHeight: "220px" }}>
              <Spinner kind="primary" label="Loading..." size="large" />
            </Container>
          )}
          {folderList?.length === 0 && !isFolGeting && (
            <EmptyState
              title="No Folders"
              subtitle={
                isAdmin
                  ? "Get started by creating a folder."
                  : "Folders are not assigned to you by the organizer."
              }
              action={false}
              mt={6}
            />
          )}

          {folderList.length > 0 &&
            folderList.map((data, i) => (
              <div
                key={i}
                ref={i + 1 == folderList?.length ? lastElementRef : null}>
                <AlbumCard
                  key={i}
                  data={data}
                  onClick={() => {
                    navigate(
                      `${location.pathname}/photos/${data.folderId
                      }?folderType=${isPhotographer || tabIndex == 1
                        ? "Photographer"
                        : "Event"
                      }`,
                      {
                        state: { albumName: data?.name },
                      },
                    );
                    localStorage.setItem("eventFID", data?.id);
                  }}
                  setEditData={setEditData}
                  setEditModalClose={setEditModalClose}
                  setDeleteModalClose={setDeleteModalClose}
                  setSwitchFolderPublicConfirmationModalClose={
                    setSwitchFolderPublicConfirmationModalClose
                  }
                  setDeleteThumbnailModalClose={setDeleteThumbnailModalClose}
                  setIsPublic={setIsPublic}
                  photograherTab={tabIndex == 1}
                  setPhotographerAccessModalClose={
                    setPhotographerAccessModalClose
                  }
                  setApproveModalClose={setApproveModalClose}
                />{" "}
              </div>
            ))}
          {isFolGeting && page !== 0 && <Loader size={"small"} />}
        </Container>
      </div>

      {/* Edit folder  */}
      <JdsModal
        header="Edit Folder"
        size="m"
        close={isEditModalClose}
        onClose={() => {
          setEditModalClose(true);
        }}>
        {!isEditModalClose && (
          <FolderForm
            isWatermarkAvailable={isWatermarkAvailable}
            editData={editData}
            onSubmit={(formData) => folderUpdateHandler(formData, editData?.id)}
            actionLoading={isFolActionLoading}
          />
        )}
      </JdsModal>

      {/* Delete Conformation */}
      <JdsModal
        size="m"
        header="Are you sure you want to delete this folder?"
        kind="dialog"
        primaryCTA={{
          title: "Okay",
        }}
        secondaryCTA={{
          title: "Cancel",
        }}
        close={isDeleteModalClose}
        onClose={() => {
          setDeleteModalClose(true);
        }}
        onPrimaryClick={() => {
          deleteFolderHandler(editData?.id);
          setDeleteModalClose(true)
        }}
        onSecondaryClick={() => setDeleteModalClose(true)}
        primaryCtaDisabled={isDeleting}
      />

      {/* Approve folder Conformation */}
      <JdsModal
        size="m"
        header="Once the folder is approved, the uploaded photos will be visible to the guest."
        kind="dialog"
        primaryCTA={{
          title: "Approve",
        }}
        secondaryCTA={{
          title: "Cancel",
        }}
        close={isApproveModalClose}
        onClose={() => {
          setApproveModalClose(true);
        }}
        onPrimaryClick={() => {
          approveFolderHandler(editData?.id);
        }}
        onSecondaryClick={() => setApproveModalClose(true)}
        primaryCtaDisabled={isApprove}
      />

      <SuccessModal
        close={isSuccessModalClosed}
        subtitle="Your folder has been created successfully."
        onClose={() => {
          setSuccessModalClose(true);
        }}
      />

      <JdsModal
        size="m"
        header="Are you sure you want to delete this thumbnail?"
        kind="dialog"
        primaryCTA={{
          title: "Okay",
        }}
        secondaryCTA={{
          title: "Cancel",
        }}
        close={isDeleteThumbnailModalClose}
        onClose={() => {
          setDeleteThumbnailModalClose(true);
        }}
        onPrimaryClick={() => {
          deleteThumbnailHandler(editData);
        }}
        onSecondaryClick={() => setDeleteThumbnailModalClose(true)}
        primaryCtaDisabled={isDeletingThumbNail}
      />

      <JdsModal
        size="m"
        header="Are you sure you want to make the change?"
        kind="dialog"
        primaryCTA={{
          title: "Okay",
        }}
        secondaryCTA={{
          title: "Cancel",
        }}
        close={switchFolderPublicConfirmationModalClose}
        onClose={() => {
          setSwitchFolderPublicConfirmationModalClose(true);
        }}
        onPrimaryClick={() => {
          makeFolderPublicApiHandler(editData);
        }}
        onSecondaryClick={() =>
          setSwitchFolderPublicConfirmationModalClose(true)
        }
        primaryCtaDisabled={isPublicLoading}>
        {/* <Container direction="row" gap={16} verticalAlign="top" horizontalAlign="space-between" style={{ margin: '24px 0' }} fullWidth>
          <Container direction="column" gap={8} style={{ width: '50%' }}>
            <Text text="Public" appearance="body-m" />
            <Text text="Photos uploaded in this folder will be available to the guests in this event." appearance="body-xs" color="primary-grey-80" />
          </Container>
          <Box>
            <FormControlLabel
              checked={isPublic}
              control={<Switch />}
              labelPlacement="start"
              onChange={() => setIsPublic(prev => !prev)}
            />
          </Box>
        </Container> */}
      </JdsModal>

      {/* Edit folder  */}
      <JdsModal
        header="Folder Access"
        size="m"
        close={isPhotographerAccessModalClose}
        onClose={() => {
          setPhotographerAccessModalClose(true);
        }}>
        {!isPhotographerAccessModalClose && (
          <PhotographerAccess folderData={editData} />
        )}
      </JdsModal>

      {isDeleting && <PageLoader open={isDeleting} label={'Deleting folder...'} style={{ flexDirection: 'column' }} />}
    </>
  );
}
